import 'focus-visible';
import Drupal from './core/Drupal';
import DDTemplates from './core/DDTemplates';
import CalendarFeed from './core/CalendarFeed';
import TermNavigation from './core/TermNavigation';
import FetchSourceImages from './core/FetchSourceImages';
import Sticky from './utils/Sticky';
import Visible from './utils/Visible';
import AccordionWrap from './core/AccordionWrap';
import AccordionFix from './core/AccordionFix';
import AccordionContainer from './core/AccordionContainer';
// import BackgroundImage from './core/BackgroundImage';
// Header Components
import Navigation from './components/Navigation';
import FixNavigation from './core/FixNavigation';
import Toolbar from './header/Toolbar';
import Headroom from './components/Headroom';
// Homepage Components
import Hero from './home/Hero';
import StayConnected from './home/StayConnected';
import WhatsHappening from './home/WhatsHappening';

// ----------------------------------------------------------------------------
// Homepage Specific Behaviors.
// ----------------------------------------------------------------------------

const homeBehaviors = () => {
  // Homepage Blocks
  document.querySelectorAll('.front .page-main .block').forEach((element) => {
    if (!element.Visible) {
      element.Visible = new Visible(element);
    }
  });

  // Hero Block
  document.querySelectorAll('.home-hero.block').forEach((element) => {
    if (!element.Hero) {
      element.Hero = new Hero(element);
    }
  });

  // Stay Connected Block
  document.querySelectorAll('.home-stay-connected.block').forEach((element) => {
    if (!element.StayConnected) {
      element.StayConnected = new StayConnected(element);
    }
  });

  // What's Happening Block
  document.querySelectorAll('.home-whats-happening.block').forEach((element) => {
    if (!element.WhatsHappening) {
      element.WhatsHappening = new WhatsHappening(element);
    }
  });

  // Homepage Block Ready State
  document.querySelectorAll('.front .page-main .block:not(.ready)').forEach((element) => {
    setTimeout(() => {
      element.classList.add('ready');
    }, 200);
  });
};

// ----------------------------------------------------------------------------
// Core Theme Behaviors.
// ----------------------------------------------------------------------------

const coreBehaviors = () => {
  // DD Template Behaviors
  if (!document.body.DDTemplates) {
    document.body.DDTemplates = new DDTemplates();
  }

  // Fix our damn menus from displaying orphaned children
  document.querySelectorAll('.main-navigation, .term-navigation').forEach((element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  document.querySelectorAll('.page-sidebar').forEach((element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main Navigation
  document.querySelectorAll('#nice-menu-3').forEach((element) => {
    if (!element.Navigation) {
      element.Navigation = new Navigation(element);
    }
  });

  // Controls the states of the menu and search states
  document.querySelectorAll('.toolbar').forEach((element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Fixed Header using Headroom.js
  document.querySelectorAll('.headroom').forEach((element) => {
    if (!element.Headroom) {
      element.Headroom = new Headroom(element);
    }
  });

  // Term Navigation
  document.querySelectorAll('.term-navigation').forEach((element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Calendar of Events View
  document.querySelectorAll('.calendar-feed').forEach((element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element);
    }
  });

  // Wraps each accordion element
  document.querySelectorAll('.accordion-heading').forEach((element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  document.querySelectorAll('.node-content').forEach((element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });

  // Pods
  document.querySelectorAll('.node-pod').forEach((pod) => {
    if (!pod.BgImage) {
      const hover = pod.querySelector('.dd-hover-dependencies .dd-hover-expand');
      const subpod = pod.querySelector('.node-teaser');
      const $classList = subpod.className;
      pod.appendChild(hover);
      pod.className += $classList;
      // pod.BgImage = new BackgroundImage(pod, {
      //   sourceSelector: '.node-upper-image img',
      //   destSelector: '.node-upper-image',
      // });
    }
  });
};

// ----------------------------------------------------------------------------
// Load homepage behaviors if we're on the frontpage.
// ----------------------------------------------------------------------------

if (document.body.classList.contains('front')) {
  Drupal.behavior(homeBehaviors);
}

// ----------------------------------------------------------------------------
// Load core behaviors.
// ----------------------------------------------------------------------------

Drupal.behavior(coreBehaviors);

// ----------------------------------------------------------------------------
// If we're in development mode...
// Open up all missing images within a new tab/window.
// ----------------------------------------------------------------------------

if (process.env.NODE_ENV === 'development') {
  document.body.FetchSourceImages = new FetchSourceImages();
}
